import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';
import * as _entityManagerProvider from '../../services/entitymanagerprovider';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SetupGuard implements CanActivate {
    constructor(private http: HttpClient, private uowService: UnitOfWorkService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return _entityManagerProvider
            .init(this.http)
            .then(() => {
                this.uowService.init();

                return true;
            })
            .catch(reason => {
                return false;
            });
    }
}
